import { render } from "./CS_TA.vue?vue&type=template&id=745f917c&scoped=true"
import script from "./CS_TA.vue?vue&type=script&lang=js"
export * from "./CS_TA.vue?vue&type=script&lang=js"

import "./CS_TA.vue?vue&type=style&index=0&id=745f917c&scoped=true&lang=css"
import "./CS_TA.vue?vue&type=style&index=1&id=745f917c&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745f917c"]])

export default __exports__